import { post } from 'aws-amplify/api'
import { buildPatientsApiUrl } from './patientsApiBaseUrl'
import { ClinicsSearchHttpError } from './clinicsSearchErrors'

const getClinicsList = async (
  plennaServiceId,
  lat,
  long,
  idToken,
  options = {}
) => {
  const body = {
    serviceId: plennaServiceId
  }

  if (lat && long) {
    body.location = {
      lat,
      long
    }
  }

  const headers = {
    'content-type': 'application/json'
  }

  if (idToken?.__raw) {
    headers.Authorization = `Bearer ${idToken.__raw}`
  }

  if (options.variant === 'search') {
    const searchBody = {
      plennaServiceId,
      ...(body.location ? { location: body.location } : {})
    }

    const endpoint = buildPatientsApiUrl('/v1/clinics/search')
    if (!endpoint) {
      console.error(
        'Missing REACT_APP_PATIENTS_API_BASE_URL for clinics search'
      )
      throw new Error('Missing patients API base URL')
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify(searchBody)
      })
      const data = await response.json()

      if (!response.ok) {
        throw new ClinicsSearchHttpError(
          response.status,
          data?.message || 'Error al obtener clínicas',
          data
        )
      }

      return data
    } catch (error) {
      if (error instanceof ClinicsSearchHttpError) {
        throw error
      }
      console.log(error)
      throw error
    }
  }

  try {
    const resp = post({
      apiName: process.env.REACT_APP_API_BASE_URL,
      path: '/api/v1/clinics',
      options: {
        headers,
        body
      }
    })
    const { body: responseBody } = await resp.response
    const data = await responseBody.json()
    return data
  } catch (error) {
    console.log(error)
    throw error
  }
}

export default getClinicsList
